import axios from "axios";
import Cookies from "js-cookie";

const baseUrl = process.env.REACT_APP_API_URL;

export const getPartner = async () => {
  const url = baseUrl + `/getPartners`;
  try {
    const response = await axios.post(url);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getInstituteMarker = async () => {
  const url = baseUrl + `/getInstituteMarker`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
